import { loginByUsername, logout, getUserInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {  encryptionData } from '@/utils/index'

const user = {
  state: {
    admin_id:'',
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    perms: [],
    setting: {
      articlePlatform: []
    },
    info:{}
  },

  mutations: {
    SET_ADMINID: (state, id) => {
      state.admin_id = id
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMS: (state, perms) => {
      state.perms = perms
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      let user = {
        mobile:userInfo.mobile.trim(),
        captcha:userInfo.captcha,
        lng:userInfo.lng,
        lat:userInfo.lat
      }
      return new Promise((resolve, reject) => {
        loginByUsername(user).then(res => {
          console.log(res,'用户名登录')
          const data = res.data
          const token = data.userinfo.token
          commit('SET_TOKEN', token)
          setToken(token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo({}).then(res => {
          const data = res.data
          console.log(res,'用户信息')
          if (data.perms && data.perms.length > 0) { // 验证返回的perms是否是一个非空数组
            commit('SET_PERMS', data.perms)
          } else {
            reject('您还没有权限，请联系后台管理员开通权限!')
          }
          commit('SET_ADMINID', data.userinfo.id) // 用户ID
          commit('SET_NAME', data.userinfo.nickname) // 名字
          commit('SET_AVATAR', data.userinfo.avatar) // 头像
          //用户信息
          commit('SET_INFO',Object.assign({},{
            'login_ip':data.userinfo.loginip,
            'login_time':data.userinfo.logintime,
            'mobile':data.userinfo.mobile,
            'avatar':data.userinfo.avatar,
            'nickname':data.userinfo.nickname,
            'is_manager_role':data.userinfo.is_manager_role,
            'manager_id': data.userinfo.manager_id
          }))
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(res => {
          const data = res.data
          commit('SET_ROLES', data.roles)
          commit('SET_PERMS', data.perms)
          commit('SET_NAME', data.nickname)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          dispatch('GenerateRoutes', data) // 动态修改权限后 重绘侧边菜单
          resolve()
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js